<div class="sub-menu-items" *ngIf="subItems && subItems.length">
  <ul>
    <li *ngFor="let subItem of subItems">
      <a>
        <span class="f-font">{{ subItem }}</span>
      </a>
    </li>
  </ul>
</div>
